<template>
  <div class="pano" ref="pano"></div>
</template>

<script>
export default {
  props: {
    view: String
  },
  data() {
    return {
      Viewer3d: undefined,
      venue_id: "nam-us-00098-fccincinnati"
    };
  },
  mounted() {
    const input_options = {
      container: this.$refs.pano,
      venue_id: this.venue_id,
      plugins: ["navigation"]
    };
    window.DVM.loadModule("3d_viewer", input_options)
      .then(this.onLoadModule)
      .catch(function(err) {
        console.error(err);
      });
  },

  methods: {
    onLoadModule(viewer3d) {
      this.Viewer3d = viewer3d;
      this.loadView();
    },
    onSubsribe(obj) {
      var nav = obj.navigation;
      if (nav) {
        this.Viewer3d.loadView3d(nav);
      }
    },
    loadView() {
      this.Viewer3d.subscribe("click_navigation_node", this.onSubsribe);
      this.Viewer3d.loadView3d({ venue_id: this.venue_id, view_id: this.view })
        .then(function(obj) {})
        .catch(function(err) {});
    }
  }
};
</script>

<style lang="scss" scoped>
.pano {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}
</style>